import React from 'react';

import { IonProgressBar } from '@ionic/react';

const ProgressBar = (props: any) => {
  return <IonProgressBar data-cy={'ProgressBar'} {...props} />;
};

export default ProgressBar;
